import { render, staticRenderFns } from "./Cosec.vue?vue&type=template&id=5d715a8d&scoped=true"
import script from "./Cosec.vue?vue&type=script&lang=js"
export * from "./Cosec.vue?vue&type=script&lang=js"
import style0 from "./Cosec.vue?vue&type=style&index=0&id=5d715a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d715a8d",
  null
  
)

export default component.exports